// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'caret-up';

export const Component = () => <path d='M4 17.25V14.5L12.5 8l8.5 6.5v2.75l-8.5-6.5z' />;

export const viewBox = '0 0 25 25';
